import { piniaAddress } from '@stores/useAddressStore';
import { createApp } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import AddressDetailsView from './AddressDetailsView.vue';

export const initAddressDetails = () => {
  if (!document.getElementById('address-details-app')) {
    return;
  }

  const app = createApp(AddressDetailsView);

  const routes = [
    {
      path: '/spaces/:id',
      name: 'address-details',
      component: AddressDetailsView,
    },
  ];

  const router = createRouter({
    routes,
    history: createWebHistory(),
  });

  app.use(router);
  app.use(piniaAddress);
  app.mount('#address-details-app');
};
